module.exports = __webpack_public_path__ + "baeeae2bc4e2f3d578b63c6622276c3b.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/minus_19_disabled.svg
// module id = 1248
// module chunks = 74